import { Outlet } from 'react-router-dom'
import './editorial.css'

export function MarketingLayout() {
  return (
    <div className="mkt">
      <Outlet />
    </div>
  )
}
